import React from "react";

import "../../style_new.css";

const TeamExpanded = () => {
  const teamMembers = [
    {
      name: "William Kuffour Bonsu",
      info: "William has about fifteen years' experience running various lines of businesses including civil and building construction, finance, and general agriculture. He is the founder and pioneer managing proprietor/director of the company. He has steered the affairs of the company since its inception and has overseen its steady growth over the past fifteen years. William holds a first degree in land economy, an MBA in Finance, and an MSc in economics, all from Kwame Nkrumah University of Science and Technology. He is a professional member of the Institute of Chartered Accountants, Ghana, the Chartered Institute of Bankers, Ghana, and the Chartered Institute of Financial Analyst-Ghana.",
      image: "./images/team-1.jpg",
      position: "Managing Director",
    },
    {
      name: "Yvonne Boateng",
      info: "Yvonne is a graduate of the University of Ghana and has been in business for the past four years. She is a director and a shareholder of the company.",
      image: "./images/team-2.jpg",
      position: "Director",
    },
    {
      name: "Isaac Stephen Agyei Mensah",
      info: "Isaac is a member of the Ghana Institution of Surveyors and the Ghana Institute of Construction. He has a Master's degree in Construction Project Management from HAN University of Applied Sciences Hogeschool van Arnhem en Nijmegen (Holland) and a BSc (Hons) Building Technology (Second Class Upper) from Kwame Nkrumah University of Science and Technology (1999-2003). He is the general manager who oversees the operational efficiency of the firm. He is also in charge of organizational health, safety, and welfare.",
      image: "./images/team-3.jpg",
      position: "General Manager",
    },
    {
      name: "Wendylove Owusu",
      info: "Wendylove holds a BSc in Business Administration. She is in charge of all support and clerical functions in the company. She supervises all support and administrative staff and manages the administrative budget. She is also in charge of all Human Resource functions of the firm.",
      image: "./images/team-4.jpg",
      position: "Administrative Manager",
    },
    {
      name: "Samuel Kuffour Bonsu",
      position: "Projects Manager",
      info: "Samuel holds an HND in Construction Management from Kumasi Technical University. He is in charge of planning, executing, and closing projects while ensuring timely completion. His role is to coordinate all site engineers and supervisors. He is also in charge of stakeholder management and negotiating and resolving conflicts with stakeholders and communities.",
      image: "./images/team-5.jpg",
    },
    // {
    //   "name": "Theophilus Ohene Asante Domfeh",
    //   "info": "Theophilus joined our organization in 2014 as an officer in our stores. He has since held various positions and risen to the rank of Head, Procurement. In his current position, Theophilus is in charge of all purchasing activities, including materials and equipment for the firm. His task is to ensure the efficient acquisition of goods and services at the best possible prices and payment terms. He has developed an effective sourcing strategy in negotiating contracts, managing supplier relationships, and monitoring inventory. His work also involves the efficient and timely distribution of procured materials and equipment to various sites for effective delivery of projects.",
    //   "image": ""
    // },
    // {
    //   "name": "Samuel Kuffour Bonsu",
    //   "info": "Samuel holds an HND in Construction Management from Kumasi Technical University. He is in charge of planning, executing, and closing projects while ensuring timely completion. His role is to coordinate all site engineers and supervisors. He is also in charge of stakeholder management and negotiating and resolving conflicts with stakeholders and communities.",
    //   "image": ""
    // },
  ];

  return (
    <>
      {/* team section start */}

      <div class="container-xxl py-5">
        <div class="container">
          <div class="row g-5 align-items-end mb-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div class="border-start border-5 border-primary ps-4">
                <h6 class="text-body text-uppercase mb-2">Our Team</h6>
                <h1 class="display-6 mb-0">Our Expert Team</h1>
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <p class="mb-0">
                Our expert team brings together skilled professionals with years
                of experience, passion, and precision. We collaborate closely to
                deliver outstanding results, ensuring every project meets the
                highest standards.
              </p>
            </div>
          </div>
          <div className="row g-4">
            {teamMembers.map((item, i) => (
              <div
                key={i}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="team-card-wrapper">
                  <div className="team-card">
                    <div className="team-card-front">
                      <img
                        className="team-card-img"
                        src={item.image}
                        alt={item.name}
                      />
                      <div className="team-text bg-white p-4">
                        <h5>{item.name}</h5>
                        <span>{item.position}</span>
                      </div>
                    </div>
                    <div
                      className="team-card-back"
                      style={{
                        borderWidth: 1,
                        borderColor: "black",
                        borderStyle: "solid",
                      }}
                    >
                      <div className="team-card-info">
                        <span>{item.info}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* team section end */}
    </>
  );
};

export default TeamExpanded;
